/* eslint-disable react/prop-types */
import React from "react";
import { Helmet } from "react-helmet";
import img_crosschain from './../img/crosschain.webp';
import img_trade from './../img/trade.webp';
import img_moon1 from './../img/moonbeam-1.webp';
import img_moon2 from './../img/moonbeam-2.webp';

export default function Mexc() {
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="/tailwind.min.css" />
        <link rel="stylesheet" href="/waitlist.css" />
        <style>
          {`
            .table-auto th, .table-auto td {
              background-color: rgba(255, 255, 255, 0);
              border: 1px solid #ddd;
              padding: 10px;
            }
            .table-auto th {
              background-color: rgba(97, 61, 147, 0.8); /* Assuming this is your brand color */
              color: #fff;
              padding: 15px;
            }
            .table-auto td:first-child {
              background-color: rgba(97, 61, 147, 0.8); /* Assuming this is your brand color */
              color: #fff;
            }
            .nested-list {
              margin-left: 2rem; /* Increased left margin for more padding */
            }
            .responsive-table {
              overflow-x: auto;
            }
          `}
        </style>
      </Helmet>
      <section className="lg:mt-[-128px] lg:pt-[128px] pt-10 sm:py-20 bg-cover bg-center sm:bg-[url('./img/roadmap_bg.jpg')]">
        <div className="container mx-auto px-10 lg:py-20">
          <div className="sm:w-2/3 grid grid-cols-1 place-items-center">
            <div className="col-span-2 text-left">
              <h1 className="pb-20 sm:pt-20 header-title text-4xl md:text-4xl leading-none lg:leading-tight">
                MEXC Delisting of the LAOS Token
              </h1>
            </div>
          </div>
        </div>
      </section>

      {/* <section
        style={{
          backgroundImage: `linear-gradient(144deg, #25143b 21.25%, #613d93 78.75%)`,
          padding: "0",
          marginTop: "0",
        }}
      >
         <CrowdloanComponent /> 
      </section> */}
      <div className="flex justify-center items-center">
        <section
          className="py-12 w-screen "
          style={{
            backgroundImage: `linear-gradient(144deg, #25143b 21.25%, #613d93 78.75%)`,
          }}
        >
          <div className=" px-10 xl:px-32 2xl:px-96">
            <p>
                We would like to inform the community that MEXC has notified us that, as of May 29th, 2025, the LAOS token will no longer be listed on their platform.
                This was a <b>unilateral decision by MEXC, not by the LAOS Foundation</b>, whose efforts have always focused on making LAOS available on both
                Centralized and Decentralized Exchanges.
            </p>
            <br />
            <p>
                LAOS remains fully tradable on decentralized exchanges Hydration and Stellaswap,
                where users can continue to engage with the token in a non-custodial environment.
                This short post aims to guide LAOS holders through the most relevant options.
            </p>
            <br />
            <p>
                The token is native to the LAOS Network, a parachain on Polkadot.
                As such, it can be moved securely and in a fully permissionless manner across the Polkadot ecosystem.
                In particular, it can be transferred to parachains that are either specialized decentralized crypto exchanges, such as Hydration, or those that host a rich ecosystem of DEXs, such as the StellaSwap DEX on Moonbeam.
            </p>
            <br />
            <ul className="list-disc list-inside">
              <p className="brandColor">
                <strong>LAOS in Hydration</strong>
              </p>{" "}
            <br />
              <p>
                To use Hydration, the following steps are recommended:
              </p>
            <br />
              <p>
                A. Place a minimal amount of HDX (Hydration’s native coin) into an account you own on Hydration. This amount is only needed to cover transaction fees. It is essential to fund this account before proceeding to step B to avoid a potential lock of your tokens.
              </p>
            <br />
              <p>
                B. Use <a href="https://app.hydration.net/cross-chain?srcChain=laos&destChain=hydration&asset=laos">Hydration’s App </a>
                   to cross-chain transfer LAOS tokens from an origin account you control on LAOS, to your Hydration account from the previous step.
              </p>
            <br />
                <div className="md:mr-[-45px]">
                    <img src={img_crosschain} alt="laos coin" />
                </div>
            <br />
              <p>
                C. Within Hydration’s App, go to Trade → Swap to exchange your LAOS tokens on Hydration into the coin of your choice. For example,
                <a href="https://app.hydration.net/trade/swap?srcChain=assethub&destChain=hydration&asset=dot&assetIn=3370&assetOut=5"> this link </a>
                selects LAOS as input currency, and DOT as final currency. You can choose many other options, including stable coins like USDT.
              </p>
            <br />
                <br />
                <div className="md:mr-[-45px]">
                    <img src={img_trade} alt="laos coin" />
                </div>
            <br />
              <p>
                You now own your desired currency on Hydration. To further operate with your coins, including exchanging them for FIAT or accessing Centralised Exchanges, please consult
                <a href="https://docs.hydration.net/"> Hydration’s documentation. </a>
              </p>
            <br />
              <p className="brandColor pt-4">
                <strong>LAOS in StellaSwap on Moonbeam</strong>
              </p>{" "}
              <br />
              <p>
                To use StellaSwap on Moonbeam, the following are recommended steps:
              </p>
            <br />
              <p>
                A. Place a minimal amount of GLMR (Moonbeam’s native coin) on an account you own in Moonbeam. You will only need this amount to pay fees on Moonbeam.
              </p>
            <br />
              <p>
                B. Use 
                <a href="https://apps.moonbeam.network/moonbeam/xcm?asset=laos"> Moonbeam’s App </a>
                to transfer LAOS tokens from an origin account you control on LAOS, to your Moonbeam account from the previous step.
              </p>
            <br />
                <br />
                <div className="md:mr-[-45px]">
                    <img src={img_moon1} alt="laos coin" />
                </div>
            <br />
              <p>
                C. Within 
                <a href="https://app.stellaswap.com/exchange/swap"> StellaSwap’s App, </a>
                go to Swap → Trade, to exchange your LAOS tokens on Moonbeam into the coin of your choice. Again, you can choose large-liquidity options like DOT and GLMR, as well as stable coins like USDT. You can even choose ETH, which can be converted via Polkadot’s secure wormhole’s bridge.
              </p>
            <br />
                <br />
                <div className="md:mr-[-45px]">
                    <img src={img_moon2} alt="laos coin" />
                </div>
            <br />
              <p>
                You now own your desired currency on Moonbeam. To further operate with your coins, including exchanging them for FIAT or accessing Centralised Exchanges, please consult
                <a href="https://docs.stellaswap.com/"> StellaSwap’s documentation. </a>
              </p>
            <br />
            </ul>
            <br />
            <br />
        <p>
            We appreciate the continued support of our community as we advance our mission to mint millions of NFTs on all blockchains.
            For further updates and support, please refer to our official channels. For all technical support, please open a Support ticket on Discord.
        </p>
          </div>
        </section>
      </div>
    </>
  );
}
